import { $ } from '@/libs/jquery/index'

$.validator.addMethod('email', function(value: string, element: HTMLElement): boolean {
  const emailCorrect: boolean = (/^[a-z0-9_\-\.+]+@([a-z0-9\-]+\.)+(([a-z\-\.]{2,7}))$/i)
    .test(value)

  return this.optional(element) || emailCorrect
}, 'Укажите верный email')
